"use client";

import { Form } from "@/components/ui/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Loader2 } from "lucide-react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import CustomInput from "../generator/fields/CustomInput";
import CustomTextArea from "../generator/fields/CustomTextArea";

const FormSchema = z.object({
  name: z.string().min(3, {
    message: "Der Name muss mindestens 3 Zeichen lang sein.",
  }),
  email: z.string().email({
    message: "Dies ist keine gültige E-Mail.",
  }),
  message: z.string().min(3, {
    message: "Der Name muss mindestens 3 Zeichen lang sein.",
  }),
});
type Inputs = z.infer<typeof FormSchema>;
type Props = {
  loadBook: () => void;
  disableReply: () => void;
  commentId: string;
  slug: string;
};

const AddReplyForm = ({ commentId, slug, loadBook, disableReply }: Props) => {
  const form = useForm<Inputs>({
    resolver: zodResolver(FormSchema),
    mode: "onChange",
  });

  const [isSending, setIsSending] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    trigger,
    clearErrors,
    formState: { errors },
  } = form;
  function onSubmit(values: z.infer<typeof FormSchema>) {
    sendValuesToApi(values);
  }

  const sendValuesToApi = async (values: z.infer<typeof FormSchema>) => {
    setIsSending(true);
    const formData = new FormData();
    formData.append("slug", slug);
    formData.append("commentUuid", commentId);
    formData.append("name", values.name);
    formData.append("message", values.message);
    formData.append("email", values.email);
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_DOMAIN_ROUTE}/api/obituary/reply/`,
        {
          method: "POST",
          body: formData,
        }
      );
      let resp = await response.json();
    } catch (e) {}
    setIsSending(false);
    disableReply();
    loadBook();
  };

  return (
    <div className="flex w-full max-w-3xl flex-col gap-4 ">
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="mx-auto flex w-full flex-col items-center justify-center gap-2"
        >
          <CustomInput
            form={form}
            name="name"
            textError="text-white/50"
            label=""
            placeholder="Ihr Name"
          />
          <CustomInput
            form={form}
            name="email"
            textError="text-white/50"
            label=""
            placeholder="Ihr Email"
          />
          <CustomTextArea
            form={form}
            name="message"
            textError="text-white/50"
            label=""
            placeholder="Schreiben Sie eine Nachricht!"
          />
          <div className="flex w-full flex-col items-center justify-between gap-2 pt-2 lg:flex-row">
            <button
              onClick={() => {
                disableReply();
              }}
              id="add-reply"
              type="button"
              className="btn secondary large custom-outline w-full lg:w-64"
            >
              Abbrechen
            </button>
            <button
              type="submit"
              className="btn secondary large solid w-full lg:w-64"
            >
              {isSending && <Loader2 className="h-4 w-4 animate-spin" />}Senden
            </button>
          </div>
        </form>
      </Form>
    </div>
  );
};

export default AddReplyForm;
